var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMorocco(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D80027;}\n\t.st1{fill:#6DA544;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M407.3,210.1H291.7L256,100.2l-35.7,109.9H104.7l93.5,67.9l-35.7,109.9L256,320l93.5,67.9L313.8,278  L407.3,210.1z M224.4,269.5l12.1-37.2h39.1l12.1,37.2v0l-31.6,23L224.4,269.5L224.4,269.5z M268.3,210.1h-24.6l12.3-37.9  L268.3,210.1z M306.6,255.8l-7.6-23.4h39.8L306.6,255.8z M213.1,232.4l-7.6,23.4l-32.2-23.4H213.1z M204.8,329.7l12.3-37.9  l19.9,14.5L204.8,329.7z M274.9,306.3l19.9-14.5l12.3,37.9L274.9,306.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorocco);
export default __webpack_public_path__ + "static/media/morocco.36b2322b2a0d2060f8c4b2ea59000911.svg";
export { ForwardRef as ReactComponent };